module.exports = __webpack_public_path__ + "static/media/1995_maleRate_femaleRate.7c89d9af.png";